import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 167,
	height: 24,
	viewBox: "0 0 167 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			style: { isolation: "isolate" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 110",
					d: "m827.315 501.163-1.664 1.978a3.864 3.864 0 0 0-2.843-1.475 3.32 3.32 0 0 0 0 6.631 4.233 4.233 0 0 0 2.843-1.33l1.68 1.783a6.817 6.817 0 0 1-4.669 2.075 5.792 5.792 0 1 1 .1-11.576 6.556 6.556 0 0 1 4.553 1.914z",
					transform: "translate(-780.749 -491.969)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 111",
					d: "M851.893 509.512v-12.03h2.794v12.03z",
					transform: "translate(-804.341 -490.785)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 112",
					d: "M873.476 511.605c0 2.691-1.906 4.475-4.749 4.475-2.859 0-4.766-1.784-4.766-4.475s1.906-4.459 4.766-4.459c2.843 0 4.749 1.768 4.749 4.459zm-6.7.032a1.97 1.97 0 1 0 1.955-2.27 2.016 2.016 0 0 0-1.959 2.271z",
					transform: "translate(-812.435 -497.255)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 113",
					d: "M904.147 516.18h-2.795v-1.443a3.056 3.056 0 0 1-2.827 1.556 3.025 3.025 0 0 1-3.118-3.34v-5.513h2.793v4.718c0 1.038.565 1.67 1.454 1.67 1.066-.016 1.7-.892 1.7-2.076v-4.313h2.795z",
					transform: "translate(-833.526 -497.453)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 114",
					d: "M934.816 509.512h-2.795v-1.151a3.146 3.146 0 0 1-2.617 1.265c-2.456 0-4.071-1.816-4.071-4.524 0-2.675 1.6-4.442 4.006-4.442a3.229 3.229 0 0 1 2.682 1.265v-4.443h2.795zm-2.795-4.345a2.014 2.014 0 0 0-1.939-2.27 2.308 2.308 0 1 0 1.939 2.27z",
					transform: "translate(-853.597 -490.785)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 115",
					d: "M963.913 499.543c2.891 0 4.556 1.427 4.556 3.956 0 2.659-1.664 4.2-4.556 4.2h-2.052v3.194h-2.875v-11.35zm-2.052 5.886h1.906c1.26 0 1.987-.633 1.987-1.832 0-1.184-.727-1.784-1.987-1.784h-1.906z",
					transform: "translate(-876.168 -492.165)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 116",
					d: "M991.315 509.512v-12.03h2.795v12.03z",
					transform: "translate(-897.851 -490.785)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 117",
					d: "M1012.317 512.367h-6.122a2.015 2.015 0 0 0 2.052 1.622 2.935 2.935 0 0 0 2.084-.892l1.47 1.444a4.994 4.994 0 0 1-3.8 1.54 4.469 4.469 0 1 1-.081-8.934c3.072-.001 4.591 2.026 4.397 5.22zm-2.682-1.508a1.628 1.628 0 0 0-1.68-1.767 1.874 1.874 0 0 0-1.81 1.767z",
					transform: "translate(-905.946 -497.255)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 118",
					d: "M1035.635 507.441h3.053l-2.762 4.248 2.956 4.491h-3.214l-1.583-2.74-1.777 2.74h-3.07l2.973-4.475-2.779-4.264h3.2l1.454 2.513z",
					transform: "translate(-923.286 -497.453)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 119",
					d: "m1081.019 510.859-.016-7.377-2.714 6.242h-1.874l-2.714-6.242v7.377h-2.569v-11.365h3.15l3.07 6.761 3.069-6.761h3.134v11.365z",
					transform: "translate(-951.385 -492.132)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 120",
					d: "M1121.226 512.367h-6.126a2.014 2.014 0 0 0 2.052 1.622 2.934 2.934 0 0 0 2.084-.892l1.47 1.444a5 5 0 0 1-3.8 1.54 4.469 4.469 0 1 1-.081-8.934c3.075-.001 4.594 2.026 4.401 5.22zm-2.682-1.508a1.628 1.628 0 0 0-1.68-1.767 1.873 1.873 0 0 0-1.809 1.767z",
					transform: "translate(-978.991 -497.255)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 121",
					d: "M1152.091 509.512h-2.791v-1.151a3.147 3.147 0 0 1-2.617 1.265c-2.456 0-4.071-1.816-4.071-4.524 0-2.675 1.6-4.442 4.006-4.442a3.229 3.229 0 0 1 2.682 1.265v-4.443h2.794zm-2.794-4.345a2.014 2.014 0 0 0-1.939-2.27 2.308 2.308 0 1 0 1.939 2.27z",
					transform: "translate(-999.324 -490.785)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 122",
					d: "M1179.938 496.849a1.47 1.47 0 1 1-1.47-1.476 1.424 1.424 0 0 1 1.47 1.476zm-2.876 11.252v-8.739h2.779v8.738z",
					transform: "translate(-1022.389 -489.373)"
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 123",
					d: "M1197.548 510.211v5.707h-2.73v-1.005a3.179 3.179 0 0 1-2.665 1.135 2.7 2.7 0 0 1-2.989-2.74c0-1.654 1.179-2.626 3.344-2.643h2.294v-.13c0-.859-.565-1.378-1.7-1.378a6.1 6.1 0 0 0-2.6.73l-.792-1.849a9.171 9.171 0 0 1 4.039-.989c2.394 0 3.783 1.184 3.799 3.162zm-2.746 2.74v-.778h-1.761c-.84 0-1.26.292-1.26.94 0 .633.452 1.037 1.228 1.037a1.763 1.763 0 0 0 1.791-1.199z",
					transform: "translate(-1030.549 -497.19)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			"data-name": "\\uD0C0\\uC6D0 12",
			cx: 2.569,
			cy: 2.569,
			r: 2.569,
			transform: "translate(23.98 10.286)",
			style: { fill: "#ef4b4b" }
		}),
		/* @__PURE__ */ _jsxs("g", {
			"data-name": "\\uADF8\\uB8F9 9158",
			children: [
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 124",
					d: "m777.143 477.348-10.179 3.362v10.84z",
					transform: "translate(-749.025 -477.348)",
					style: {
						fillRule: "evenodd",
						fill: "#fa0"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 125",
					d: "m713.5 493.756 10.161 3.433 6.373-8.706z",
					transform: "translate(-713.277 -484.75)",
					style: {
						fill: "#3fbc9e",
						fillRule: "evenodd"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 126",
					d: "m751.5 519.072-6.248-2.116-.13 10.718z",
					transform: "translate(-734.419 -503.675)",
					style: {
						fill: "#683eff",
						fillRule: "evenodd"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					"data-name": "\\uD328\\uC2A4 127",
					d: "m712.83 506.074 10.094 14.261.069-10.834z",
					transform: "translate(-712.83 -496.442)",
					style: {
						fill: "#435eff",
						fillRule: "evenodd"
					}
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
